module.exports = __webpack_public_path__ + "media/Paint_IN.abff45af.mp4";